import * as MapPatterns from './MapPatterns';
import { MapTileType } from '../../editor/MapTypes';

export interface DefaultMapPattern {
  id: string;
  name: string;
  description: string;
  difficultyTags: string[];
  generatePattern: (grid: MapTileType[][]) => void;
}

export const DEFAULT_MAP_PATTERNS: DefaultMapPattern[] = [
  {
    id: 'default_spiral_path',
    name: 'Spiral Path',
    description: 'Classic spiral pattern winding from outside to center, then to goal',
    difficultyTags: ['spiral', 'classic', 'beginner'],
    generatePattern: MapPatterns.generateSpiralPattern,
  },
  {
    id: 'default_zig_zag_corridors',
    name: 'Zig-Zag Corridors',
    description: 'Alternating horizontal and vertical corridors creating a zig-zag pattern',
    difficultyTags: ['zigzag', 'corridors', 'beginner'],
    generatePattern: MapPatterns.generateZigZagPattern,
  },
  {
    id: 'default_grid_lock',
    name: 'Grid Lock',
    description: 'Grid-based maze with multiple paths and dead ends',
    difficultyTags: ['grid', 'labyrinth', 'medium'],
    generatePattern: MapPatterns.generateGridLabyrinthPattern,
  },
  {
    id: 'default_serpents_trail',
    name: "Serpent's Trail",
    description: 'Single winding path like a snake from spawn to goal',
    difficultyTags: ['snake', 'path', 'beginner'],
    generatePattern: MapPatterns.generateSnakePathPattern,
  },
  {
    id: 'default_chamber_system',
    name: 'Chamber System',
    description: 'Multiple connected chambers with narrow passages',
    difficultyTags: ['chambers', 'rooms', 'medium'],
    generatePattern: MapPatterns.generateChamberPattern,
  },
  {
    id: 'default_hexagonal_pattern',
    name: 'Hexagonal Pattern',
    description: 'Hexagonal-like pattern with interconnected cells',
    difficultyTags: ['honeycomb', 'hexagonal', 'medium'],
    generatePattern: MapPatterns.generateHoneycombPattern,
  },
  {
    id: 'default_river_delta',
    name: 'River Delta',
    description: 'Multiple branching paths like a river delta',
    difficultyTags: ['delta', 'branches', 'hard'],
    generatePattern: MapPatterns.generateRiverDeltaPattern,
  },
  {
    id: 'default_boxed_in',
    name: 'Boxed In',
    description: 'Nested boxes with openings creating a maze',
    difficultyTags: ['boxes', 'nested', 'medium'],
    generatePattern: MapPatterns.generateBoxMazePattern,
  },
  {
    id: 'default_diagonal_flow',
    name: 'Diagonal Flow',
    description: 'Diagonal corridors creating a flowing pattern',
    difficultyTags: ['diagonal', 'flow', 'medium'],
    generatePattern: MapPatterns.generateDiagonalFlowPattern,
  },
  {
    id: 'default_open_arena',
    name: 'Open Arena',
    description: 'Minimal walls, mostly open space with strategic chokepoints',
    difficultyTags: ['open', 'arena', 'beginner'],
    generatePattern: MapPatterns.generateOpenArenaPattern,
  },
];

